import { memo, useCallback } from "react";
import SearchActions from "../SearchActions";
import { Serializer } from "@shared/mirage/helpers/Serializer";
import { EntityTableStateStorage } from "@mirage/components/entityTable/EntityTableStateStorage";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";
import "./PropertySearch.css";
import { usePropertySearchStore } from "@publicPortal/store/store";
import PropertySearchFields from "./PropertySearchFields";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";

const pp = new PublicPortalRoutingService();

const PropertySearch = memo(() => {
    const navigate = useStableNavigate();
    const addressDetails = usePropertySearchStore((s) => s.propertySearch);
    const updatePropertySearchFilter = usePropertySearchStore((s) => s.updatePropertySearchFilter);
    const resetPropertySearch = usePropertySearchStore((s) => s.resetPropertySearch);

    const setStateModifier = useCallback(
        (modifier: Partial<PropertySearchFilter>) => {
            updatePropertySearchFilter(modifier);
        },
        [updatePropertySearchFilter]
    );
    const onClear = useCallback(() => resetPropertySearch(), [resetPropertySearch]);
    const onSubmit = useCallback(() => {
        const filter = { uprn: addressDetails.filter.uprn };
        const searchParams = Serializer.toQueryParamsNotEmptyOnly(filter);
        EntityTableStateStorage.clear("propertySearch");
        navigate(`${pp.SearchRoute("PropertySearch", searchParams)}`);
    }, [addressDetails.filter.uprn, navigate]);

    return (
        <>
            <PropertySearchFields state={addressDetails.filter} setStateModifier={setStateModifier} />
            <SearchActions onCancelHandler={onClear} onSubmitHandler={onSubmit} />
        </>
    );
});

export default PropertySearch;
